import React from 'react';
import styled from 'styled-components';

import { spaceXS } from '@xingternal/tokens';

import { InnerElement } from './pagination-item.styles';

type PaginationItemProps = {
  truncated?: boolean;
  children?: React.ReactNode;
  current?: boolean;
  href?: string;
  onClick?: () => void;
};

const ListItem = styled.li`
  margin-left: ${spaceXS};
  margin-right: ${spaceXS};
`;

export const PaginationItem: React.FC<PaginationItemProps> = ({ truncated, children, current, href, onClick }) => (
  <ListItem>
    <InnerElement href={href} onClick={onClick} $truncated={truncated} $current={current}>
      {truncated ? '…' : children}
    </InnerElement>
  </ListItem>
);
